import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import jp from './utils/locales/jp.json';

i18n
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: 'jp',
    fallbackLng: 'en',
    debug: true,
    resources: {
      jp,
    },
    returnNull: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    nsSeparator: '::',
  });

export default i18n;
